module.exports = __webpack_public_path__ + "img/menu_44.dd7fec9b.png";